module.exports = __webpack_public_path__ + "img/logo.fbefbe23.fbefbe23.png";